export const PROGRAMA_RECOMPENSA_LOAD_SALDO_CLIENTE =
  "PROGRAMA_RECOMPENSA_LOAD_SALDO_CLIENTE";
export const PROGRAMA_RECOMPENSA_AJUSTAR_SALDO =
  "PROGRAMA_RECOMPENSA_AJUSTAR_SALDO";
export const PROGRAMA_RECOMPENSA_EXPORTAR_SALDOS =
  "PROGRAMA_RECOMPENSA_EXPORTAR_SALDOS";
export const PROGRAMA_RECOMPENSA_BUSCAR_CLIENTES_CRITERIO =
  "PROGRAMA_RECOMPENSA_BUSCAR_CLIENTES_CRITERIO";
